import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { BodyLink, BodyText, Caption, Flex } from '@kvdbil/components';

const OptionTitleRow = styled(Flex)`
  width: 100%;
`;

const OptionTitle = styled(BodyText)`
  margin: 0;
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => theme.colors.text.dark};
`;

const OptionPrice = styled(BodyLink)`
  margin: 0;
  flex-shrink: 0;
  margin-left: 0.75rem;
  color: ${({ theme }) => theme.colors.text.dark};
`;

const OptionDescription = styled(Caption)`
  margin: 0.25rem 0 0;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.grayscaleToned.dark3};
`;

export interface DeliveryOptionTitleBlockProps {
  title: ReactNode;
  price: ReactNode;
  description?: ReactNode;
}

export const DeliveryOptionTitleBlock = ({
  title,
  price,
  description
}: DeliveryOptionTitleBlockProps) => (
  <Flex direction="column" align="stretch" gap={0}>
    <OptionTitleRow justify="space-between" align="flex-start" gap={0}>
      <OptionTitle as="span">{title}</OptionTitle>
      <OptionPrice as="span">{price}</OptionPrice>
    </OptionTitleRow>
    {description ? <OptionDescription>{description}</OptionDescription> : null}
  </Flex>
);

export default DeliveryOptionTitleBlock;
